import { apiFetch } from './client'
import type { ClinicalRole, MyPractice, OrgPractice, StaffMember } from '../types/clinical'

export async function listStaff(practiceId: number): Promise<StaffMember[]> {
  const res = await apiFetch(`/api/practices/${practiceId}/staff`)
  if (!res.ok) throw new Error('Failed to load staff')
  return res.json() as Promise<StaffMember[]>
}

export async function inviteStaff(
  practiceId: number,
  data: { email: string; clinical_role: ClinicalRole; is_practice_admin?: boolean },
): Promise<StaffMember> {
  const res = await apiFetch(`/api/practices/${practiceId}/staff/invite`, {
    method: 'POST',
    body: JSON.stringify({ is_practice_admin: false, ...data }),
  })
  if (!res.ok) {
    const err = (await res.json()) as { detail?: string }
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Failed to send invitation')
  }
  return res.json() as Promise<StaffMember>
}

export async function revokeStaffMember(practiceId: number, staffId: number): Promise<void> {
  const res = await apiFetch(`/api/practices/${practiceId}/staff/${staffId}`, { method: 'DELETE' })
  if (!res.ok) throw new Error('Failed to revoke staff member')
}

export async function acceptInvite(token: string): Promise<StaffMember> {
  const res = await apiFetch('/api/staff/accept-invite', {
    method: 'POST',
    body: JSON.stringify({ token }),
  })
  if (!res.ok) {
    const err = (await res.json()) as { detail?: string }
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Failed to accept invitation')
  }
  return res.json() as Promise<StaffMember>
}

export async function getMyPractices(): Promise<MyPractice[]> {
  const res = await apiFetch('/api/me/practices')
  if (!res.ok) throw new Error('Failed to load practices')
  return res.json() as Promise<MyPractice[]>
}

export async function getMyOrgPractices(): Promise<OrgPractice[]> {
  const res = await apiFetch('/api/me/org-practices')
  if (!res.ok) throw new Error('Failed to load org practices')
  return res.json() as Promise<OrgPractice[]>
}

export async function updatePracticeVatRate(practiceId: number, defaultVatRate: number): Promise<{ default_vat_rate: string }> {
  const res = await apiFetch(`/api/practices/${practiceId}/vat-rate`, {
    method: 'PATCH',
    body: JSON.stringify({ default_vat_rate: defaultVatRate }),
  })
  if (!res.ok) {
    const err = (await res.json()) as { detail?: string }
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Failed to update VAT rate')
  }
  return res.json() as Promise<{ default_vat_rate: string }>
}
